import { render, staticRenderFns } from "./Modifier.vue?vue&type=template&id=0bd5dc0c&scoped=true"
import script from "./Modifier.vue?vue&type=script&lang=js"
export * from "./Modifier.vue?vue&type=script&lang=js"
import style0 from "./Modifier.vue?vue&type=style&index=0&id=0bd5dc0c&prod&lang=scss&scoped=true"
import style1 from "./Modifier.vue?vue&type=style&index=1&id=0bd5dc0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5dc0c",
  null
  
)

export default component.exports